export enum ViewMode {
  Print = 'print',
  Screen = 'screen',
}
